import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie';
import { ApiModule } from '../api/api.module';
import { ModalService } from './../modals/modal.service';
import { AssignmentsService } from './assignments.service';
import { BuildingService } from './building.service';
import { CommentService } from './comment.service';
import { FileService } from './file.service';
import { MessagingService } from './messaging/messaging.service';
import { ObservationListService } from './observation-list.service';
import { AnecdotalObservationService } from './Observation/anecdotal-observation.service';
import { DiffService } from './Observation/diff/diff.service';
import { FormalService } from './Observation/formal/formal.service';
import { NTPERubricFormBuilderService } from './Observation/ntpe/ntpe-rubric-form-builder.service';
import { NtpeService } from './Observation/ntpe/ntpe.service';
import { RatingFormService } from './Observation/ratingform-service';
import { SloObservationService } from './Observation/slo-observation.service';
import { SpmService } from './Observation/spm.service';
import { WalkthroughObservationService } from './Observation/walkthrough-observation.service';
import { PaetepPortalService } from './paetep-portal.service';
import { PaetepUserHelperService } from './paetep-user-helper/paetep-user-helper.service';
import { PaetepUserService } from './paetep-user.service';
import { PermissionsHelperService } from './permissions-helper/permissions-helper.service';
import { PermissionsService } from './permissions/permissions.service';
import { PresetManagementService } from './preset-management-services/preset-management-service.service';
import { ResourceService } from './resource/resource.service';
import { RubricFormBuilderService } from './rubric-form-builder/rubric-form-builder.service';
import { RubricService } from './rubric/rubric.service';
import { SecurityService } from './security/security.service';
import { SignatureService } from './signatures.service';
import { SupervisionManagementService } from './supervision-management.service';
import { UserRoleHelperService } from './user-role/user-role-helper.service';
import { ViewService } from './view.service';
import { ContentService } from './content.service';
import { OnboardingService } from './onboarding.service';
import { PrincipalSloService } from './Observation/principal-slo/principal-slo.service';
import { ParamHelperService } from './param-helper-services/param-helper.service';
import { SupervisionManagementHelpersService } from './supervision-management-helpers/supervision-management-helpers.service';
import { UserEntryFormBuilderService } from './user-entry-form-builder/user-entry-form-builder.service';
import { CustomSupervisionService } from './custom-supervision/custom-supervision.service';
import { PvassDataService } from './pvass-data.service';


@NgModule({
    imports: [
        CommonModule,
        ApiModule,
        FormsModule
    ],
    providers: [
        AnecdotalObservationService,
        AssignmentsService,
        BuildingService,
        CookieService,
        CommentService,
        CustomSupervisionService,
        DiffService,
        FileService,
        FormalService,
        MessagingService,
        ModalService,
        NTPERubricFormBuilderService,
        NtpeService,
        ObservationListService,
        PaetepPortalService,
        PaetepUserService,
        PaetepUserHelperService,
        ParamHelperService,
        PermissionsHelperService,
        PermissionsService,
        PresetManagementService,
        PrincipalSloService,
        RatingFormService,
        ResourceService,
        RubricFormBuilderService,
        RubricService,
        SecurityService,
        SignatureService,
        SloObservationService,
        SpmService,
        SupervisionManagementService,
        SupervisionManagementHelpersService,
        ViewService,
        WalkthroughObservationService,
        UserEntryFormBuilderService,
        UserRoleHelperService,
        ContentService,
        OnboardingService,
        PvassDataService
    ]
})
export class ServiceModule { }
